@if (displayStyle() === 'flatten') {
<div class="flatten-container">

  @for (qualifier of getOtherQualifiers(); track $index; let i = $index) {
    <button class="flatten-label" [ngClass]="{ 'selected-label': _selectedOther === qualifier }" (click)="handleOtherSelectionChange(qualifier)" >
      {{ qualifier.name }}
      <span *ngIf="_selectedOther === qualifier" class="sr-only">{{' is selected'}}</span>
    </button>
  }

  @if(getOtherQualifiers().length > 0 && getSideQualifier().length > 0) {
  <div class="flatten-divider"></div>
  }

  <ng-container *ngFor="let qualifier of getSideQualifier(); let i = index">
    <button class="side-label" [title]="qualifier.name" [ngClass]="{ 'selected-label': _selectedSide === qualifier }"
      (click)="onSideSelectionChange(qualifier)">
      @if (_selectedSide === qualifier) {
      <cwo-icon class="check-icon" [name]="iconNameType.check" />
      }
      {{ qualifier.name }}
    </button>
  </ng-container>
</div>
} @if (displayStyle() === 'dropdown') {
<div class="dropdown-container" *transloco="let t">
  <div class="select-wrapper">
    <select
      id="qualifier-dropdown-select"
      [ngStyle]="{width: widthToSet ? widthToSet + 'px' : null}"
      class="qualifier-dropdown-select"
      [ngClass]="{ selected: _selectedOther }"
      [attr.aria-label]="storeConfig?.xtraLabel ? t('shared_components.choices.ingredients.qualifiers.select_qualifier') : null"
      (change)="handleSelectChange($event)"
      (keydown)="handleDropdownKeyDown($event)"
      (blur)="handleDropdownBlur($event)"
      [(ngModel)]="_selectedOtherName"
    >
      <option value="" disabled>{{storeConfig?.xtraLabel ?? t("shared_components.choices.ingredients.qualifiers.clear")}}</option>
      @for (qualifier of qualifiers(); track $index) {
        @if(qualifier.name !== 'Side'){
          <option [value]="qualifier.name">{{qualifier.name}}</option>
        }
      }
      @if(_selectedOther){
        <option value="separator" disabled>──────────</option>
        <option value="clear">{{t("shared_components.choices.ingredients.qualifiers.clear")}}</option>
      }
    </select>
    <div class="icon-wrapper" [ngClass]="{ selected: _selectedOther }">
      <cwo-icon [name]="iconNameType.arrow" class="icon" />
    </div>
  </div>

  @if (getOtherQualifiers().length > 0 && getSideQualifier().length > 0) {
    <div class="flatten-divider"></div>
  }

  <ng-container *ngFor="let qualifier of getSideQualifier(); let i = index">
    <button class="side-label" [title]="qualifier.name" [ngClass]="{ 'selected-label': _selectedSide === qualifier }"
      (click)="onSideSelectionChange(qualifier)">
      @if (_selectedSide === qualifier) {
      <cwo-icon class="check-icon" [name]="iconNameType.check" />
      }
      {{ qualifier.name }}
    </button>
  </ng-container>
</div>
}
